export default "__VITE_ASSET__DliJ8f_g__"